import { API, Auth } from "aws-amplify";
import axios from "axios";
import { adminApiUrl } from "./MainInterface";

export abstract class ApiBase {
  protected apiName: string;
  protected urlPath: string;
  protected authToken: string | undefined;
  protected accessToken: string | undefined;

  abstract onApiName(): string;
  abstract onUrlPath(): string;

  constructor() {
    this.apiName = this.onApiName();
    this.urlPath = this.onUrlPath();
    this.authToken = undefined;
    this.accessToken = undefined;
  }

  protected async getToken() {
    try {
      const session = await Auth.currentSession();
      this.authToken = `Bearer ${session.getIdToken()?.getJwtToken()}`;
    } catch (error) {
      return undefined;
    }

    return this.authToken;
  }

  protected async getAcsToken() {
    try {
      const session = await Auth.currentSession();
      this.accessToken = session.getAccessToken()?.getJwtToken();
    } catch (error) {
      return undefined;
    }

    return this.accessToken;
  }

  protected async requestPost(requestBody: any): Promise<any> {
    let header: any = { Authorization: "abcd" };
    let authToken: any;
    let acsToken: any;

    if (this.apiName === "MainApi" || this.apiName === "ChannelApi") {
      authToken = await this.getToken();
      acsToken = await this.getAcsToken();
      if (authToken !== undefined) {
        header = {
          Authorization: authToken,
        };
      }
    } else if (this.apiName === "UnAuth") {
      header = {
        "x-api-key": process.env.REACT_APP_UNAUTH_X_API_KEY,
      };
    }

    requestBody.access_token = acsToken;
    const request = {
      headers: header,
      body: requestBody,
    };
    try {
      const response = await API.post(this.apiName, this.urlPath, request);
      return response;
    } catch (error) {
      return { code: "500", response: { error_msg: error } };
    }
  }

  protected async requestBuffer(requestBody: any): Promise<any> {
    if (this.apiName === "AdminApi") {
      // Stream 형식으로 Request
      const response = await axios.post(adminApiUrl, requestBody);
      return response.data;
    }
  }
}
